import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  Container,
  Card,
  Form,
  Table,
  ButtonGroup,
  Button,
  InputGroup
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import { ThreeDots } from 'react-loader-spinner';
import { resetSearchText, getUserAccessModules, updateSearch, getUserAccessPage, updateCurrentPage, updateUserAccess } from "../../3.Store/UserAccessSlice";
import './UserAccess.css';
import Pagination from "../../2.Commons/Pagination";

const UserAccessList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [loading, setLoading] = useState(false);
  const lists = useSelector(state => state.UserAccessSlice.userAccessList);
  const modulelists = useSelector(state => state.UserAccessSlice.moduleList);
  const user = useSelector(state => state.UserAccessSlice.user);
  const loading = useSelector(state => state.UserAccessSlice.loading);
  const search = useSelector(state => state.UserAccessSlice.search);
  const currentPage = useSelector(state => state.UserAccessSlice.currentPage);
  const totalPages = useSelector(state => state.UserAccessSlice.totalPages);
  const { searchText } = search;
  const role = JSON.parse(localStorage.getItem("roles"));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  console.log(lists);

  useEffect(() => {
    if (!role || !role.includes("HR-USER-ACCESS")) {  // Check required role
      localStorage.clear();
      window.location.href = "/Login";
    }
    else {
      dispatch(getUserAccessPage({ page: currentPage,  ...search }));
      dispatch(getUserAccessModules());
    }
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Define your custom module order
  const customOrder = [
    "HR-EMP-MGT",         
    "HR-EMP-PRO-MGT",
    "HR-SU-TRANS",
    "HR-L-APPLY",
    "HR-L-WITHDRAWN",
    "HR-M-APPLY",
    "HR-L-SUMMARY",
    "HR-L-APPROVAL",
    "HR-M-BENEFIT",
    "HR-L-AWARD",
    "HR-L-ACCRUAL",
    "HR-L-PRORATED",
    "HR-USER-ACCESS",
    "HR-HOLIDAY",
    "SU-L-APPROVAL",
    "SU-M-BENEFIT",
    "U",
  ];

  const handleSearch = (e) => {
    const entity = { ...search, searchText: e.target.value }
    dispatch(updateSearch(entity));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBtnSearch();
    }
  };

  const handleBtnSearch = () => {
    dispatch(updateCurrentPage(1));
    dispatch(getUserAccessPage({ page: 1,  ...search }));
  };

  const handleBtnBack = () => {
    dispatch(resetSearchText());
    navigate("/");
  };

  const handleClickView = (id, name, module) => {
    const entity = { ...user, 
      employee: {
        id: id,
        fullname: name
      },
      modules: module
    }
    dispatch(updateUserAccess(entity));
    navigate(`/UserAccessForm/${id}`);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      // setCurrentPage(currentPage - 1);
      dispatch(updateCurrentPage(currentPage - 1));
      dispatch(getUserAccessPage({ page: currentPage - 1, ...search }));
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      // setCurrentPage(currentPage + 1);
      dispatch(updateCurrentPage(currentPage + 1));
      dispatch(getUserAccessPage({ page: currentPage + 1, ...search }));
    }
  };

  const handlePageChange = (page) => {
    dispatch(updateCurrentPage(page));
    dispatch(getUserAccessPage({ page: page, ...search }));
  };

  const moduleMap = modulelists.reduce((acc, module) => {
    acc[module.id] = module.description;
    return acc;
  }, {});  

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">User Access</h1>
      
        <br/><br/>
        <InputGroup className="mb-3">
          <Form.Control placeholder="Search" name="searchText" value={searchText} onChange={handleSearch} onKeyPress={handleKeyPress} />
          <Button className="SearchIconBtn" onClick={handleBtnSearch}>
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </InputGroup>
        <br/>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div style={{ overflowX: 'auto' }}>
          <Table className="my-fixed-table" style={{ fontSize: "14px" }}>
            <thead>
              <tr>
                {isMobile ? (
                  <>
                    <th style={{ width: "80%" }}>Name & Role</th>
                    <th style={{ width: "20%", textAlign: 'center' }}>Action</th>
                  </>
                ) : (
                  <>
                  <th style={{ width: "200px" }}>Name</th>
                  <th style={{ width: "400px" }}>Role</th>
                  <th style={{ textAlign: 'center', verticalAlign: 'middle', width: "50px" }}>Action</th>
                  </>
                )}
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {lists.length > 0 ? (
                  lists.map(employee => (
                    <tr key={employee.id} style={{ cursor: "pointer" }}>
                      {isMobile ? (
                        <>
                          <td>
                            {employee.fullname
                                .toLowerCase()
                                .split(' ')
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .join(' ')}
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                              {/* {employee.module_ids
                                .map((module, index) => (
                                  <Button
                                    key={index}
                                    variant="secondary"
                                    size="sm"
                                    className="custom-sm-button"
                                  >
                                    {module}
                                  </Button>
                                ))} */}
                                {[...employee.module_ids]
                                  .sort((a, b) => {
                                    const aIndex = customOrder.indexOf(a);
                                    const bIndex = customOrder.indexOf(b);
                                    const max = customOrder.length;
                                    return (aIndex === -1 ? max : aIndex) - (bIndex === -1 ? max : bIndex);
                                  })
                                  .map((moduleId, index) => (
                                    <Button
                                      key={index}
                                      variant="secondary"
                                      size="sm"
                                      className="custom-sm-button"
                                    >
                                      {moduleMap[moduleId] || moduleId}
                                    </Button>
                                  ))}
                            </div>
                          </td>
                          <td style={{ textAlign: 'center', verticalAlign: 'middle' }} onClick={() => handleClickView(employee.id, employee.fullname, employee.module_ids)}>
                            <FontAwesomeIcon icon={faPlusCircle} style={{ color: "blue" }} />
                          </td>
                        </>
                      ) : (
                        <>
                          <td>
                            {employee.fullname
                                .toLowerCase()
                                .split(' ')
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .join(' ')}
                          </td>
                          <td style={{ whiteSpace: "normal", padding: "10px" }}>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                              {/* {employee.module_ids
                                .map((module, index) => (
                                  <Button
                                    key={index}
                                    variant="secondary"
                                    size="sm"
                                    className="custom-sm-button"
                                  >
                                    {module}
                                  </Button>
                                ))} */}
                                {[...employee.module_ids]
                                  .sort((a, b) => {
                                    const aIndex = customOrder.indexOf(a);
                                    const bIndex = customOrder.indexOf(b);
                                    const max = customOrder.length;
                                    return (aIndex === -1 ? max : aIndex) - (bIndex === -1 ? max : bIndex);
                                  })
                                  .map((moduleId, index) => (
                                    <Button
                                      key={index}
                                      variant="secondary"
                                      size="sm"
                                      className="custom-sm-button"
                                    >
                                      {moduleMap[moduleId] || moduleId}
                                    </Button>
                                  ))}
                            </div>
                          </td>
                          <td style={{ textAlign: 'center', verticalAlign: 'middle' }} onClick={() => handleClickView(employee.id, employee.fullname, employee.module_ids)}>
                            <FontAwesomeIcon icon={faPlusCircle} style={{ color: "blue" }} />
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3">No results found</td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};
export default UserAccessList;